import React from "react";

export const ElementContainer = ({
  styles,
  label,
  labelPosition,
  children,
  displayError,
  errorMessage,
}) => {
  return (
    <div className={styles.container}>
      {label && !labelPosition && (
        <label className={styles.label}>{label}</label>
      )}
      {children}
      <div className={styles.error}>
        <label>{displayError && errorMessage}</label>
      </div>
      {label && labelPosition && (
        <label className={styles.label}>{label}</label>
      )}
    </div>
  );
};
